/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2020 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */
import React from 'react';
import PdfViewerContainer from './PdfViewerContainer';
import TocService from './services/TocService';
import EpubTocService from './services/EpubTocService';
import PxeTocService from './services/PxeTocService';
import HotspotService from './services/HotspotService';
import SaveHotspotService from './services/SaveHotspotService';
import DeleteHotspotService from './services/DeleteHotspotService';
import Asset from './model/Asset';
import Hotspot from './model/Hotspot';
import EpubAsset from './model/EpubAsset';
import ResourceService from './services/ResourceService';
import ResourcePanel from './model/Resources';

export default {
  path: ['/books/:bookid/preview', '/books/:bookid/preview/:pageid'],
  exact: true,
  services: [
    new TocService(),
    new HotspotService(),
    new SaveHotspotService(),
    new DeleteHotspotService(),
    new EpubTocService(),
    new PxeTocService(),
    new ResourceService()
  ],
  stores: [
    {
      name: 'asset',
      spec: Asset,
      saveLocally: false,
      initialState: {
        assetToc: {}
      }
    },
    {
      name: 'epubAsset',
      spec: EpubAsset,
      saveLocally: false,
      initialState: {
        epubAssetToc: {}
      }
    },
    {
      name: 'hotspot',
      spec: Hotspot,
      saveLocally: false,
      initialState: {}
    },
    {
      name: 'resourcePanel',
      spec: ResourcePanel,
      saveLocally: false,
      initialState: {
        limitByRoles: [],
        name: '',
        relatedTo: [
          {
            productId: '',
            resourceType: ''
          }
        ],
        subtopic: [
          {
            contentTypeValue: '',
            description: '',
            downloadLink: '',
            fileType: '',
            isDownloadable: false,
            isUserDownloadable: false,
            launchBrowser: false,
            name: '',
            pageId: '',
            sizeInMB: '',
            url: ''
          }
        ]
      }
    }
  ],
  render: (props) => <PdfViewerContainer {...props} />
};
